/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import type {
  ConsentAcceptanceSummaryDto,
  ConsentDocumentDtoV2,
  ConsentDtoV2,
  FindByOrganisationIdParams,
  FindConsentsByIdsParams,
  FindConsentsParams,
  GetFunnelSuitableParams,
  GetMissingParams,
  SendNotificationForAwxMigrationCampaignParams,
  SendNotificationForEmiLicenceCampaignParams,
} from '../dto'
import { HttpClient, RequestParams } from './http-client'

export class ConsentControllerV2<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http
  }

  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name SendNotificationForEmiLicenceCampaign
   * @request POST:/api/v2/organisation/consents/campaign/emi-licence/notify
   */
  sendNotificationForEmiLicenceCampaign = (
    query: SendNotificationForEmiLicenceCampaignParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/organisation/consents/campaign/emi-licence/notify`,
      method: 'POST',
      query: query,
      ...params,
    })

  static sendNotificationForEmiLicenceCampaignPath =
    '/v2/organisation/consents/campaign/emi-licence/notify'
  static sendNotificationForEmiLicenceCampaignMethod = 'POST'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name SendNotificationForAwxMigrationCampaign
   * @request POST:/api/v2/organisation/consents/campaign/awx-migration/notify
   */
  sendNotificationForAwxMigrationCampaign = (
    query: SendNotificationForAwxMigrationCampaignParams,
    params: RequestParams = {},
  ) =>
    this.http.request<void, any>({
      path: `/v2/organisation/consents/campaign/awx-migration/notify`,
      method: 'POST',
      query: query,
      ...params,
    })

  static sendNotificationForAwxMigrationCampaignPath =
    '/v2/organisation/consents/campaign/awx-migration/notify'
  static sendNotificationForAwxMigrationCampaignMethod = 'POST'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindByOrganisationId
   * @request GET:/api/v2/organisation/consents
   */
  findByOrganisationId = (query: FindByOrganisationIdParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/organisation/consents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findByOrganisationIdPath = '/v2/organisation/consents'
  static findByOrganisationIdMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetAcceptanceSummaryForEmiLicenceCampaign
   * @request GET:/api/v2/organisation/consents/campaign/emi-licence
   */
  getAcceptanceSummaryForEmiLicenceCampaign = (params: RequestParams = {}) =>
    this.http.request<ConsentAcceptanceSummaryDto, any>({
      path: `/v2/organisation/consents/campaign/emi-licence`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAcceptanceSummaryForEmiLicenceCampaignPath =
    '/v2/organisation/consents/campaign/emi-licence'
  static getAcceptanceSummaryForEmiLicenceCampaignMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetAcceptanceSummaryForAwxMigrationCampaign
   * @request GET:/api/v2/organisation/consents/campaign/awx-migration
   */
  getAcceptanceSummaryForAwxMigrationCampaign = (params: RequestParams = {}) =>
    this.http.request<ConsentAcceptanceSummaryDto, any>({
      path: `/v2/organisation/consents/campaign/awx-migration`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getAcceptanceSummaryForAwxMigrationCampaignPath =
    '/v2/organisation/consents/campaign/awx-migration'
  static getAcceptanceSummaryForAwxMigrationCampaignMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsents
   * @request GET:/api/v2/consents
   */
  findConsents = (query: FindConsentsParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findConsentsPath = '/v2/consents'
  static findConsentsMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetSoftwareOnly
   * @request GET:/api/v2/consents/software-only/{country}
   */
  getSoftwareOnly = (
    country:
      | 'UNDEFINED'
      | 'AC'
      | 'AD'
      | 'AE'
      | 'AF'
      | 'AG'
      | 'AI'
      | 'AL'
      | 'AM'
      | 'AN'
      | 'AO'
      | 'AQ'
      | 'AR'
      | 'AS'
      | 'AT'
      | 'AU'
      | 'AW'
      | 'AX'
      | 'AZ'
      | 'BA'
      | 'BB'
      | 'BD'
      | 'BE'
      | 'BF'
      | 'BG'
      | 'BH'
      | 'BI'
      | 'BJ'
      | 'BL'
      | 'BM'
      | 'BN'
      | 'BO'
      | 'BQ'
      | 'BR'
      | 'BS'
      | 'BT'
      | 'BU'
      | 'BV'
      | 'BW'
      | 'BY'
      | 'BZ'
      | 'CA'
      | 'CC'
      | 'CD'
      | 'CF'
      | 'CG'
      | 'CH'
      | 'CI'
      | 'CK'
      | 'CL'
      | 'CM'
      | 'CN'
      | 'CO'
      | 'CP'
      | 'CR'
      | 'CS'
      | 'CU'
      | 'CV'
      | 'CW'
      | 'CX'
      | 'CY'
      | 'CZ'
      | 'DE'
      | 'DG'
      | 'DJ'
      | 'DK'
      | 'DM'
      | 'DO'
      | 'DZ'
      | 'EA'
      | 'EC'
      | 'EE'
      | 'EG'
      | 'EH'
      | 'ER'
      | 'ES'
      | 'ET'
      | 'EU'
      | 'EZ'
      | 'FI'
      | 'FJ'
      | 'FK'
      | 'FM'
      | 'FO'
      | 'FR'
      | 'FX'
      | 'GA'
      | 'GB'
      | 'GD'
      | 'GE'
      | 'GF'
      | 'GG'
      | 'GH'
      | 'GI'
      | 'GL'
      | 'GM'
      | 'GN'
      | 'GP'
      | 'GQ'
      | 'GR'
      | 'GS'
      | 'GT'
      | 'GU'
      | 'GW'
      | 'GY'
      | 'HK'
      | 'HM'
      | 'HN'
      | 'HR'
      | 'HT'
      | 'HU'
      | 'IC'
      | 'ID'
      | 'IE'
      | 'IL'
      | 'IM'
      | 'IN'
      | 'IO'
      | 'IQ'
      | 'IR'
      | 'IS'
      | 'IT'
      | 'JE'
      | 'JM'
      | 'JO'
      | 'JP'
      | 'KE'
      | 'KG'
      | 'KH'
      | 'KI'
      | 'KM'
      | 'KN'
      | 'KP'
      | 'KR'
      | 'KW'
      | 'KY'
      | 'KZ'
      | 'LA'
      | 'LB'
      | 'LC'
      | 'LI'
      | 'LK'
      | 'LR'
      | 'LS'
      | 'LT'
      | 'LU'
      | 'LV'
      | 'LY'
      | 'MA'
      | 'MC'
      | 'MD'
      | 'ME'
      | 'MF'
      | 'MG'
      | 'MH'
      | 'MK'
      | 'ML'
      | 'MM'
      | 'MN'
      | 'MO'
      | 'MP'
      | 'MQ'
      | 'MR'
      | 'MS'
      | 'MT'
      | 'MU'
      | 'MV'
      | 'MW'
      | 'MX'
      | 'MY'
      | 'MZ'
      | 'NA'
      | 'NC'
      | 'NE'
      | 'NF'
      | 'NG'
      | 'NI'
      | 'NL'
      | 'NO'
      | 'NP'
      | 'NR'
      | 'NT'
      | 'NU'
      | 'NZ'
      | 'OM'
      | 'PA'
      | 'PE'
      | 'PF'
      | 'PG'
      | 'PH'
      | 'PK'
      | 'PL'
      | 'PM'
      | 'PN'
      | 'PR'
      | 'PS'
      | 'PT'
      | 'PW'
      | 'PY'
      | 'QA'
      | 'RE'
      | 'RO'
      | 'RS'
      | 'RU'
      | 'RW'
      | 'SA'
      | 'SB'
      | 'SC'
      | 'SD'
      | 'SE'
      | 'SF'
      | 'SG'
      | 'SH'
      | 'SI'
      | 'SJ'
      | 'SK'
      | 'SL'
      | 'SM'
      | 'SN'
      | 'SO'
      | 'SR'
      | 'SS'
      | 'ST'
      | 'SU'
      | 'SV'
      | 'SX'
      | 'SY'
      | 'SZ'
      | 'TA'
      | 'TC'
      | 'TD'
      | 'TF'
      | 'TG'
      | 'TH'
      | 'TJ'
      | 'TK'
      | 'TL'
      | 'TM'
      | 'TN'
      | 'TO'
      | 'TP'
      | 'TR'
      | 'TT'
      | 'TV'
      | 'TW'
      | 'TZ'
      | 'UA'
      | 'UG'
      | 'UK'
      | 'UM'
      | 'US'
      | 'UY'
      | 'UZ'
      | 'VA'
      | 'VC'
      | 'VE'
      | 'VG'
      | 'VI'
      | 'VN'
      | 'VU'
      | 'WF'
      | 'WS'
      | 'XI'
      | 'XU'
      | 'XK'
      | 'YE'
      | 'YT'
      | 'YU'
      | 'ZA'
      | 'ZM'
      | 'ZR'
      | 'ZW',
    params: RequestParams = {},
  ) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents/software-only/${country}`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getSoftwareOnlyPath = '/v2/consents/software-only/${country}'
  static getSoftwareOnlyMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetMissing
   * @request GET:/api/v2/consents/missing
   */
  getMissing = (query: GetMissingParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents/missing`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getMissingPath = '/v2/consents/missing'
  static getMissingMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetFunnelSuitable
   * @request GET:/api/v2/consents/funnel-suitable/{country}
   */
  getFunnelSuitable = (
    { country, ...query }: GetFunnelSuitableParams,
    params: RequestParams = {},
  ) =>
    this.http.request<ConsentDtoV2, any>({
      path: `/v2/consents/funnel-suitable/${country}`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static getFunnelSuitablePath = '/v2/consents/funnel-suitable/${country}'
  static getFunnelSuitableMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name GetGeneralFunnelSuitable
   * @request GET:/api/v2/consents/funnel-suitable-general
   */
  getGeneralFunnelSuitable = (params: RequestParams = {}) =>
    this.http.request<ConsentDocumentDtoV2[], any>({
      path: `/v2/consents/funnel-suitable-general`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static getGeneralFunnelSuitablePath = '/v2/consents/funnel-suitable-general'
  static getGeneralFunnelSuitableMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsentsByIds
   * @request GET:/api/v2/consents/by-ids
   */
  findConsentsByIds = (query: FindConsentsByIdsParams, params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/consents/by-ids`,
      method: 'GET',
      query: query,
      format: 'json',
      ...params,
    })

  static findConsentsByIdsPath = '/v2/consents/by-ids'
  static findConsentsByIdsMethod = 'GET'
  /**
   * No description
   *
   * @tags consent-controller-v-2
   * @name FindConsentsByApplicationId
   * @request GET:/api/v2/application/consents
   */
  findConsentsByApplicationId = (params: RequestParams = {}) =>
    this.http.request<ConsentDtoV2[], any>({
      path: `/v2/application/consents`,
      method: 'GET',
      format: 'json',
      ...params,
    })

  static findConsentsByApplicationIdPath = '/v2/application/consents'
  static findConsentsByApplicationIdMethod = 'GET'
}
